import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CacheService } from 'src/app/cache.service';


export interface Product {

  productId: number,
  productKind: string,
  productType: { typeId: number, productType: string };
  productCategory: { categoryId: number, category: string };
  productItem: { itemId: number, item: string };
  partNumber: number;
}

export interface ProductInventory {

  productCategory: string,
  productType: string,
  productItem: string,
  productId: number,
  customerStock: boolean,
  totalPieces:number,
  availablePieces: number,
  orderedPieces: number,
  orderCount: number,
  stockPiecesCount: number,
  stockCount: number,
  reservedStock: number,
  onHandStock: number
}
//===========================================
export interface Item {
  item: string;
  productId: number;
  partNumber: string;
}

export interface Type {
  productType: string;
  items: Item[];
}

export interface Category {
  category: string;
  types: Type[];
}

export interface Kind {
  name: string;
  categories: Category[];
}

export interface ProductResponse {
  [kind: string]: {
    [category: string]: {
      [type: string]: Item[];
    };
  };
}
//===========================================


export interface OrderRow {
  rowIndex?: number;
  category?: any;
  productType?: any;
  item?: any;
  orderPrice?: number;
  orderId?: any;
  productId?: any;
  productKind?: any;

}
export class ProductType {

  typeId: number;
  productType: string;
  reorderLevel : number;
  reorderAvailable: number;

  constructor() { }
}

@Injectable({
  providedIn: 'root'
})

export class ProductsService {




  private readonly productsCacheKey = 'products';


  constructor(private httpClient: HttpClient, private cacheService: CacheService) { }

  public getProducts(): Observable<Product[]> {

       const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
       return this.httpClient.get<Product[]>('/api/v1/product/', { headers })
          .pipe(catchError(this.errorHandler));
//     const cachedProducts$ = this.cacheService.getCache<Product[]>(this.productsCacheKey);
//
//     if (cachedProducts$.value) {
//       console.log('Returning cached products:', cachedProducts$.value);
//       return cachedProducts$.asObservable();
//     }
//
//     const headers = new HttpHeaders({
//       Authorization: sessionStorage.getItem('basicauth') || '',
//     });
//
//     console.log('Fetching products from server...');
//     return this.httpClient.get<Product[]>('/api/v1/product/', { headers }).pipe(
//       tap((products) => {
//         console.log('Caching products:', products);
//         this.cacheService.setCache(this.productsCacheKey, products);
//       }),
//       catchError(this.errorHandler)
//     );
  }



  public getProductTypes(): Observable<ProductType[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<ProductType[]>('/api/v1/productType/', { headers })
      .pipe(catchError(this.errorHandler));
  }

  updateProductType(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.put<any>('/api/v1/productType/', bean, { headers }).pipe(catchError(this.errorHandler));
  }

  public createProductType(obj: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/api/v1/productType/', obj, { headers }).pipe(catchError(this.errorHandler));
  }

  public deleteProductType(Id: number) {
    // console.log("productType: " + Id);
    return this.httpClient.delete('api/v1/productType/' + Id);
  }

  errorHandler(error: HttpErrorResponse) {
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }



  getProductsRows() {
    return this.httpClient.get<any>('assets/products.json')
      .toPromise()
      .then(res => <OrderRow[]>res.data)
      .then(data => { return data; });
  }
  public createProductByName(product: { productTypeName: string, productCategoryName: string, productItemName: string, productKind: string  , partNumber : string}): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/api/v1/product/createByName', product, { headers })
      .pipe(catchError(this.errorHandler));
  }


  // ------------------------



  getProductsByKind(kind: string): Observable<ProductResponse> {
    let apiUrl = '/api/v1/product/by-kind/';
    return this.httpClient.get<ProductResponse>(`${apiUrl}${kind}`).pipe(
      map(data => {
        // Restructure the data to put SBM category first
        if (data && typeof data === 'object' && Object.keys(data).length > 0) {
          const firstKey = Object.keys(data)[0]; // Usually "SWG"
          const categories = data[firstKey];
          
          if (categories && typeof categories === 'object') {
            // Create a new object with SBM first, followed by other categories
            const sbmCategory = categories['SBM'];
            if (sbmCategory) {
              const newCategories = {
                'SBM': sbmCategory  // Put SBM first
              };
              
              // Add all other categories
              Object.keys(categories)
                .filter(key => key !== 'SBM')
                .forEach(key => {
                  newCategories[key] = categories[key];
                });
              
              // Replace the original categories with our reordered version
              data[firstKey] = newCategories;
              console.log('Restructured categories with SBM first:', Object.keys(data[firstKey]));
            }
          }
        }
        return data;
      })
    );
  }

  public clearProductsCache(): void {
    console.log('Clearing products cache...');
    this.cacheService.clearCache(this.productsCacheKey);
  }

  public getProductsByCategorySBM(): Observable<Product []> {
    let apiUrl = '/api/v1/product/product-category/sbm/';
    return this.httpClient.get<Product[]>(`${apiUrl}`);
  }
}
